import classNames from 'classnames';
import { FC, ReactElement } from 'react';
import { TooltipWrapper } from '../TooltipWrapper';
import styles from './index.module.scss';

interface InfoBlockItemProps {
  name: string | number;
  value: string | number | ReactElement;
  isSuccess?: boolean;
  tooltip?: string;
}

export const InfoBlockItem: FC<InfoBlockItemProps> = ({ name, value, isSuccess, tooltip }) => (
  <div className={styles.infoBlockItem}>
    <div
      className={classNames(styles.infoBlockItemName, {
        [styles.infoBlockItenNameWithTooltip]: tooltip,
      })}
    >
      {name}
      <span className={styles.infoBlockTooltipWrapper}>
        {tooltip && <TooltipWrapper tooltip={tooltip} />}
      </span>
    </div>
    <div
      className={classNames(styles.infoBlockItemValue, {
        [styles.infoBlockItemValueSuccess]: isSuccess,
      })}
    >
      {value ?? '-'}
    </div>
  </div>
);
